export default __webpack_public_path__ + "static/media/Yellow0000.21636ce7.png";